import { Component, OnInit } from '@angular/core';
import { parse } from 'querystring';
import { LoginService } from '../../Shared/Service/login_service';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSelectChange, MatTableDataSource } from '@angular/material';
import { DashboarduiService } from '../../Shared/Service/dashboardui.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import beautify from 'xml-beautifier';
export const MY_FORMATS={
  parse:{
    dateInput: 'LL',
  },
  display:{
    dateInput:'LL',
    monthYearLabel:'MMM YYYY',
    dateAllLabel:'LL',
    monthyearAllLabel:'MMMM YYYY'
  }
}
export class idsProductList{
  id:number;
  status:String;
  hotelname:String;
  fromdate:Date;
  toodate:Date;
  type:any
}
@Component({
  selector: 'app-ohip-log',
  templateUrl: './ohip-log.component.html',
  styleUrls: ['./ohip-log.component.css'],
  providers:[LoginService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]

    },
    {provide:MAT_DATE_FORMATS,useValue:MY_FORMATS}
  ]
})
export class OhipLogComponent implements OnInit {

  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, 
    private datePipe: DatePipe) { 
      
    }
    searchBarFilter: boolean = false;
    Val: string;
    isProgressing: Boolean = false;
    Userid: any = [];
    errorMsgSubscription: boolean;
    errorMessage: string;
    displayContent: boolean;
    statusResult: string;
    apiresult: any;
    dropdownDeptData: any
    selectedDeptItems: any;
    Pmscodevalue: any;
    dropdownSettingsDept: IDropdownSettings = {};
    totalcount: any = 0;
    today = new Date();
    today1 = new Date();
    selectedFRMDate: any = new Date(this.today.setDate(this.today.getDate()));
    selectedTOODate: any = new Date(this.today1.setDate(this.today1.getDate()));
    requestPayload: any;
    idsProductList: idsProductList[] = [];
    dataSource: MatTableDataSource<idsProductList>;
    filterProperty: any;
    pageSize = 50;
    status:void;
    JSONName: any;
    defaultData: any;
    display: Boolean = false;
    hotellistproperty: any;
    hotellist: any = [] = [];
    displayedColumns = ['Status','operation','token','createdatetime','FXRequest','OperaRequest','OperaResponse','FXResponse'];
    hidesearchfilter(){
      this.Val='';
      this.searchBarFilter=false
    }
  ngOnInit() {
    this.isProgressing=true;
    this.Userid=localStorage.getItem("Username");
    console.log(this.Userid)
    this.errorMsgSubscription=true
    this.statusResult="not sent"
    this.errorMessage="Please select property and load"
    this.displayContent=false
    this.CallIDSUserProperties();
    this.dropdownSettingsDept={
      idField:'propertyCode',
      textField:'propertyName',
      defaultOpen:false,
      allowSearchFilter:true,
      singleSelection:true,
      closeDropDownOnSelection:true,
      itemsShowLimit:7,
      noDataAvailablePlaceholderText:'No Data Found',
      searchPlaceholderText:"Search Hotel Code / Name"
    }
  }
  CallIDSUserProperties()
  {
    this.Userid=localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.GetOHIPLogPropertyList()
    .subscribe(
      data=>{
        console.log('New Screeb Data',data)
        this.apiresult=data;
        this.dropdownDeptData=this.apiresult
        this.hotellistproperty = this.hotellist;
        /* this.selectedDeptItems=this.getDimensionsByFilter("All");
        console.log('this.StoreValuetest',this.selectedDeptItems[0].propertyCode);
        this.Pmscodevalue=this.selectedDeptItems[0].propertyCode
        console.log('this.Pmscodevalue =',this.Pmscodevalue)
        console.log('Property 113 =',data) */
        this.isProgressing=false
      }
    );
  }
  getDimensionsByFilter(propertyCode: any) 
  {
    console.log('dropdownDeptData =', this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }
  changepropertysearch()
  {
    if(this.selectedDeptItems)
    {
      this.searchBarFilter=false
      this.Val='';
      if(this.selectedDeptItems.length>0)
      {
        console.log('if condition')
        this.totalcount=0;
        console.log('selectedDeptItems =',this.selectedDeptItems)
        this.errorMsgSubscription=true
        this.errorMessage="Please select property and load"
        this.displayContent=false
        this.Pmscodevalue=this.selectedDeptItems[0].propertyCode
        console.log('pms code value =',this.Pmscodevalue)
      }
      else
      {
        console.log('Else condition zero')
        this.errorMsgSubscription=true
        this.errorMessage="Please select property and load"
        this.displayContent=false
      }
    }
    else
    {
      console.log('Property Not Selected')
    }
  }
  GetCommonMethodForLog() {
    this.searchBarFilter = true
   /*  this.PGF = "0";
    this.PGT = "50"; */
    this.ReadOHIPLog();
  }
  ReadOHIPLog()
  {
    this.isProgressing=true;
    this.selectedFRMDate=this.datePipe.transform(this.selectedFRMDate,'yyyy-MM-dd');
    this.selectedTOODate=this.datePipe.transform(this.selectedTOODate,'yyyy-MM-dd');
    console.log('SelectedProperty Result = ',this.Pmscodevalue)
    console.log('SelectedFRMDate Result = ',this.selectedFRMDate)
    console.log('SelectedTOODate Result',this.selectedTOODate)
    console.log('Status Result = ',this.statusResult)
    if (this.selectedTOODate < this.selectedFRMDate){
      this.isProgressing=false;
      this.toastr.error('From date should be less than To date.');
    }
    else
    {
      this.requestPayload={
        "PMSCODE":this.Pmscodevalue,
        "FRMDATE":this.selectedFRMDate,
        "TOODATE":this.selectedTOODate,
        "STATUS":this.statusResult,
        "SEARCH":this.Val
      }
      console.log('requestPayload =',this.requestPayload)
      this.apiCallIdsService.ReadOHIPLog(this.requestPayload)
      .subscribe((data)=>
      {
        console.log('response =',data);
        if(data.length<1)
        {
          this.displayContent=false
          this.errorMsgSubscription=true
          this.errorMessage="No Data Found"
          this.toastr.error(this.errorMessage);
          this.isProgressing=false;
        }
        else
        {
          this.errorMsgSubscription=false
          this.displayContent=true
          this.idsProductList=data;
          this.filterProperty=this.idsProductList
          this.totalcount=data.length
          this.dataSource=new MatTableDataSource(this.idsProductList)
          this.toastr.success('Data Load Successfully');
          this.isProgressing=false
        }
      });
    }
  }
  Search(event: any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { propertyCode: { toString: () => string; }; propertyName: { toString: () => string; } }) => {
      return res.propertyCode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.propertyName.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if (event == '') {
      this.Val = '';
      this.totalcount = 0
      this.ReadOHIPLog()
    }
  }
 pageEvent(e:any)
 {
  console.log('pageEvent =',e)
  var PageIndex=e.pageIndex;
  console.log('PageIndex =',PageIndex)
  this.pageSize=e.pageSize
  console.log('PageSize =',this.pageSize)
  this.ReadOHIPLog();
 }
 
//  ShowXML(token:any,jsontype:any)
//  {
//   this.status=this.LoadXML(token,jsontype)
//  }
 LoadXML(ID:any,jsontype:any)
 {
  this.isProgressing=true;
  console.log('ID',ID);
  console.log('jsontype',jsontype);
  this.apiCallIdsService.GetOHIPJson(ID,jsontype)
  .subscribe(data=>{
    console.log('Response =', data[0].jsonData)
    if(data.length<1)
    {
      this.toastr.error('No data to load');
    }
    else
    {
      
      if(jsontype=='FXRequest')
      {
        this.JSONName="FX Request XML"
      }
      else if(jsontype=='OperaRequest')
      {
        this.JSONName='Opera Request XML'
      }
      else if(jsontype=='OperaResponse')
      {
        this.JSONName='Opera Response XML'
      }
      else if(jsontype=='FXResponse')
      {
        this.JSONName='FX Response XML'
      }
      const json=beautify(data[0].jsonData);
      console.log(json);
      this.defaultData=json;
      this.display=true;
      this.isProgressing=false;
    }
  },
  error=>{
    this.toastr.error("Failed to load requests !");
    this.isProgressing=false
  },
)

 }
 closemodaldialog(){
  this.display=false;
 }
}
//Indhuja 23-10-2024